<template>
  <div>
    <b-row class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <label class="w-100">
          {{ $t("catalogs.Limmeuble_est_soumis_à_un_plafond_de_majorité") }}
        </label>
        <b-form-checkbox
          :value="1"
          :unchecked-value="0"
          :checked="building.with_majority"
          class="d-inline"
          switch
          @change="updateBuilding('with_majority', $event)"
        />
      </b-col>
    </b-row>

    <b-row v-if="!building.with_majority" class="justify-content-center">
      <b-col cols="12" sm="8">
        <hr />
        <p class="px-2">
          Si sélectionné, l'article 22 de la loi du 10 juillet 1965 alinéa 2 sera activé :
          "lorsqu'un copropriétaire possède une quote-part des parties communes supérieure à la
          moitié, le nombre de voix dont il dispose est réduit à la somme des voix des autres
          copropriétaires" ou vous pouvez modifier le plafond de majorité à votre guise.
        </p>
      </b-col>
    </b-row>

    <b-row v-if="building.with_majority" class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <label>{{ $t("catalogs.article22") }} ?</label>
        <b-form-checkbox
          :value="1"
          :unchecked-value="0"
          :checked="building.article22"
          switch
          @change="updateBuilding('article22', $event)"
        />
      </b-col>
      <b-col v-if="building.article22" class="mt-4" cols="12" sm="7">
        <hr />
        <p class="px-2">
          L’article 22 de la loi du 10 Juillet 1965 alinéa 2 dispose que "lorsqu'un copropriétaire
          possède une quote-part des parties communes supérieure à la moitié, le nombre de voix dont
          il dispose est réduit à la somme des voix des autres copropriétaires".
        </p>
        <hr />
      </b-col>
    </b-row>
    <b-row v-if="building.with_majority && !building.article22" class="justify-content-center mb-4">
      <b-col cols="12" sm="6">
        <label>{{ $t("catalogs.Définir_le_plafond_de_majorité") }}</label>
        <ValidationProvider
          ref="vee-building-majority-parts"
          v-slot="{ errors, classes }"
          :name="'plafond de majorité'"
          rules="required|min_value:0|max_value:100"
        >
          <div class="input-percent">
            <b-input
              type="number"
              :value="building.majority_parts"
              @input="updateBuilding('majority_parts', $event ? Number($event) : null)"
            />
            <span>%</span>
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
        <label class="mt-3">Texte du plafond de majorité</label>
        <b-textarea
          rows="4"
          :value="building.with_majority_text"
          @input="updateBuilding('with_majority_text', $event)"
        />
      </b-col>
    </b-row>

    <!-- Example in PV -->
    <!-- !!!: sync with code from documents (2021.10.20) -->
    <b-row v-if="building.with_majority" class="justify-content-center">
      <b-col cols="12" sm="6">
        <label class="mb-1">
          Exemple de mode d'affichage dans PV avec les options choisies&nbsp;:
        </label>

        <b-card class="bg-light">
          <div v-if="building.article22">
            En vertu de l’article 22, alinéa 2, de la loi du 10 juillet 1965, le nombre de voix dont
            dispose le copropriétaire majoritaire <span class="nowrap">« NOM PRENOM »</span> sera
            réduit à la somme des voix des autres copropriétaires. Ainsi,
            <span class="nowrap">« NOM PRENOM »</span> dispose de 3000 voix au lieu de 7000.
          </div>
          <div v-else>
            Le nombre de voix seront réduit
            <span v-if="building.with_majority_text">pour la raison suivant</span> :
            <div>
              <br />
              <!-- eslint-disable vue/no-v-html -->
              <p v-if="building.with_majority_text" v-html="showBr(building.with_majority_text)" />
            </div>
            <ul>
              <li>NOM_UN PRENOM_UN dispose de 200 voix au lieu de 800</li>
              <li>NOM_DEUX PRENOM_DEUX dispose de 200 voix au lieu de 300</li>
              <li>NOM_TROIS PRENOM_TROIS dispose de 200 voix au lieu de 700</li>
            </ul>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center building-step3-multiple">
      <b-col cols="12" sm="8">
        <label>Sélectionnez les majorités utilisées pour ce bâtiment :</label>
        <v-multiselect
          v-model="majorities"
          :options="majoritiesOptions"
          :multiple="true"
          placeholder="Sélectionnez les majorités"
          selected-label="Choisi"
          select-label=""
          deselect-label="Décochez"
          label="name"
          track-by="name"
          :preselect-first="false"
        >
        </v-multiselect>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    building: {
      type: Object,
      default: () => {
        return {};
      },
    },
    majoritiesOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    buildingMajorities: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      majorities: [],
    };
  },
  watch: {
    "building.with_majority"(val) {
      if (!val) {
        this.updateBuilding("article22", 0);
        this.updateBuilding("majority_parts", null);
      } else if (val) {
        this.updateBuilding("article22", 1);
      }
    },
    "building.article22"(val) {
      if (val) {
        this.updateBuilding("majority_parts", null);
      }
    },
    majorities(val) {
      if (val) {
        this.$emit("updateBuildingMajorities", val);
      }
    },
  },
  created() {
    this.majorities = JSON.parse(JSON.stringify(this.buildingMajorities));
  },
  methods: {
    updateBuilding(key, value) {
      this.$emit("updateBuilding", key, value);
    },
  },
};
</script>
